import { Box } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

export function CompactDataGrid({ rows, columns, height = "520px", ...props }) {
  return (
    <Box sx={{ width: "100%", height, minHeight: 320 }}>
      <DataGrid
        rows={rows}
        columns={columns}
        density="compact"
        rowHeight={42}
        columnHeaderHeight={38}
        pageSizeOptions={[10, 25, 50]}
        initialState={{
          pagination: {
            paginationModel: {
              page: 0,
              pageSize: 10,
            },
          },
        }}
        disableRowSelectionOnClick
        hideFooterSelectedRowCount
        {...props}
      />
    </Box>
  );
}
